import { ReactComponent as CheckedIcon } from "../../../../assests/images/checked.svg";
import unCheckedIcon from "../../../../assests/icons/uncheck.png";
import { useTranslation } from "react-i18next";
import { Divider, Empty, Table, Button } from "antd";
import { accNoFormat, amountFormat } from "../../../../services/common.service";
import { useNavigate } from "react-router";
import { useState } from "react";

export default function LoanGridView({
  dataSource = [],
  handleChange,
  setVisible,
  setSelectedDetails,
  noRecords,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  return (
    <div style={{ padding: "0px" }}>
      <Table
        dataSource={dataSource}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        style={{ cursor: "pointer" }}
        tableLayout="fixed"
        rowKey={"accountNo"}
        pagination={false}
        bordered
        expandable={{
          defaultExpandAllRows: false,
          expandRowByClick: true,
          expandedRowKeys: expandedRowKeys,

          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <CheckedIcon
                onClick={(e) => onExpand(record, e)}
                height={18}
                className="checked"
              />
            ) : (
              <img
                src={unCheckedIcon}
                onClick={(e) => onExpand(record, e)}
                height={18}
                className="unchecked"
              />
            ),
          onExpand: (expanded, record) => {
            if (expanded) {
              setExpandedRowKeys([record.accountNo]);
            } else {
              setExpandedRowKeys([]);
            }
          },
          expandedRowRender: (account) => (
            <div className="d-flex align-items-center">
              <Button
                type="default"
                className="secondary-btn"
                onClick={() =>
                  navigate("/accounts/loan/summary", {
                    state: { ...account },
                  })
                }
              >
                {t("pages.my_accounts.common_my_accounts.ac_details", {
                  defaultValue: "A/c Details",
                })}
              </Button>
              <Divider type="vertical" />
              <Button
                type="default"
                className="secondary-btn"
                onClick={() =>
                  navigate("/accounts/loan/statement", {
                    state: { ...account },
                  })
                }
              >
                {t("navigation.statement", {
                  defaultValue: "Statement",
                })}
              </Button>
            </div>
          ),
        }}
        sticky={true}
        columns={[
          {
            title: "Account Number",
            key: "accountNo",
            dataIndex: "accountNo",
            width: 180,
          },
          {
            title: "Account Name",
            dataIndex: "accountName",
            key: "accountName",
            ellipsis: true,
          },
          {
            title: "Branch Name",
            dataIndex: "branchName",
            key: "branchName",
            ellipsis: true,
          },

          {
            title: "Loan Description",
            dataIndex: "accountTypeDesc",
            key: "accountTypeDesc",
            ellipsis: true,
          },
          {
            title: "Outstanding Amount",
            key: "outstandingAmt",
            width: 200,
            align: "right",
            render: (account) => (
              <>
                <span>
                  {amountFormat(
                    account.outstandingAmt,
                    account.accountCurrency
                  )}
                </span>
              </>
            ),
          },
        ]}
      />
    </div>
  );
}
